import _ from 'lodash';
import { FieldArrayRenderProps } from 'formik/dist/FieldArray';

export type AccountType = {
	value: string;
	label: string;
	dataId: string;
};

export const handleAllSelectionForCheckboxArray = (
	event: any,
	type: AccountType,
	arrayHelpers: FieldArrayRenderProps,
	accountTypesSelected: string[]
) => {
	if (event.target.checked) {
		if (type.value !== 'all') {
			const index = accountTypesSelected.indexOf('all');
			if (index >= 0) {
				arrayHelpers.remove(index);
			}
		} else {
			_.forEach(accountTypesSelected, () => {
				arrayHelpers.pop();
			});
		}
		arrayHelpers.push(type.value);
	} else {
		if (type.value !== 'all') {
			arrayHelpers.remove(accountTypesSelected.indexOf(type.value));

			if (accountTypesSelected.length === 1) {
				arrayHelpers.push('all');
			}
		}
	}
};
